import styled from 'styled-components'

export const Card = styled.div`
  overflow: hidden;
  background-color: #fff;
  border-radius: ${props => (props.hasTestABCard ? '8px' : '4px')}; 
  position: relative;
  display: flex;
  width: inherit;
  flex-direction: ${props => (props.isHorizontal ? 'row' : 'column')};

  background: ${props => (props.background ? props.background : 'white')};
  box-shadow: ${props => 
    props.hasTestABCard ? 'none' : props.shadow ? props.shadow 
    : '0 2px 9px 0 rgba(158, 184, 209, 0.41)'};
  border: ${props => (props.hasTestABCard ? '1px solid #D6D6DE' : 'none')}; 
`